import { AgenziaModel } from '../../crm/modules/settings/models/agenzia.model';
import { RoleModel } from './auth.model';

export class UserModel {
  public id!: number;
  public firstname!: string;
  public lastname!: string;
  public email!: string;
  public username!: string;
  public color = '#000000';
  public agenzia!: AgenziaModel;
  public roles = new Array<RoleModel>();
}
